// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__OhqF6","content":"LoadingAlert_content__3_QV0"};